import { ChartLegendComponent } from './legend.component';
import type { ChartType } from 'chart.js';

export const htmlLegendPlugin = {
  id: 'htmlLegend',
  afterUpdate(chart: any, args: any, options: any) {
    const legendComponent = options.legendComponent as ChartLegendComponent;
    const items = chart.options.plugins.legend.labels.generateLabels(chart);
    legendComponent.createLegend(items, chart);
  },
};

declare module 'chart.js' {
  interface PluginOptionsByType<TType extends ChartType> {
    htmlLegend?: {
      containerID: string;
      legendComponent: ChartLegendComponent | null;
    };
  }
}
